/**
 * D09 研究页 Top 卡推导：缺失（null）不参与最大/最小值、排序与结论。
 * 全部缺失 → 无榜首（「暂无可比较数据」）；部分缺失 → 只对有效项排名并返回复盖数。
 * 前端纯函数（无 Next 依赖，可被 tsx 单测）。
 */

/** 取字段最大项；null 视作缺失不参与比较。返回 { top, valid, total } */
export function pickTop<T>(rows: T[], field: (r: T) => number | null | undefined): { top: T | null; valid: number; total: number } {
  let top: T | null = null;
  let best: number | null = null;
  let valid = 0;
  for (const r of rows) {
    const v = field(r);
    if (v == null || !isFinite(v)) continue;
    valid++;
    if (best == null || v > best) {
      best = v;
      top = r;
    }
  }
  return { top, valid, total: rows.length };
}

/** 统计某字段有效值 ≥ threshold 的数量；缺失不参与。 */
export function countAbove<T>(rows: T[], field: (r: T) => number | null | undefined, threshold: number): number {
  let n = 0;
  for (const r of rows) {
    const v = field(r);
    if (v == null || !isFinite(v)) continue;
    if (v >= threshold) n++;
  }
  return n;
}

/** 排序：缺失项恒排末尾（不参与胜出），有效项按 desc。 */
export function sortValidDesc<T>(rows: T[], field: (r: T) => number | null | undefined): T[] {
  const valid = rows.filter((r) => {
    const v = field(r);
    return v != null && isFinite(v);
  });
  const invalid = rows.filter((r) => {
    const v = field(r);
    return v == null || !isFinite(v);
  });
  valid.sort((a, b) => (field(b) as number) - (field(a) as number));
  return [...valid, ...invalid];
}
